// Persistent per-device identifier for student device-binding.
// A stable UUID is stored in localStorage and sent on student login so the
// backend can lock a student account to the first device it signs in from.
const DEVICE_KEY = "sa_device_id";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "dev-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
}

export function getDeviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

// A short human-friendly device label (browser + OS) for the admin panel.
export function getDeviceLabel() {
  const ua = (navigator.userAgent || "").toLowerCase();
  const os = /android/.test(ua) ? "Android"
    : /iphone|ipad|ipod/.test(ua) ? "iOS"
    : /windows/.test(ua) ? "Windows"
    : /mac os/.test(ua) ? "macOS"
    : /linux/.test(ua) ? "Linux"
    : "Device";
  const browser = /edg/.test(ua) ? "Edge"
    : /chrome|crios/.test(ua) ? "Chrome"
    : /firefox|fxios/.test(ua) ? "Firefox"
    : /safari/.test(ua) ? "Safari"
    : "Browser";
  return `${browser} on ${os}`;
}
